import React, { PropsWithChildren } from 'react';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { jssPreset, StylesProvider } from '@mui/styles';
import { create } from 'jss';
import { appTheme } from './theme';
import { GlobalStyles } from '@mui/material';
import { globalStyle } from './styles';

const jss = create({ plugins: jssPreset().plugins });

export const AppStylingProvider: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={appTheme}>
        <StylesProvider jss={jss}>
          <GlobalStyles styles={globalStyle} />
          {children}
        </StylesProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};
